import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { ADMIN_API_URL_SUBPATH } from '@/constants';
import { axiosInstance, Order, ORDERS } from '@/core';

export const useOrder = () => {
  const queryUrl = `${ADMIN_API_URL_SUBPATH}/${ORDERS}`;

  const useOrderQuery = (id: number) =>
    useQuery<AxiosResponse<Order>>({
      queryKey: ['order', id],
      queryFn: () => axiosInstance.get(`${queryUrl}/${id}`),
      enabled: !!id,
    });

  const updateStatusMutation = useMutation({
    mutationKey: ['updateOrderStatus'],
    mutationFn: ({ id, status }: { id: number; status: string }) =>
      axiosInstance.put(`${queryUrl}/${id}/status`, null, { params: { status } }),
  });

  // Receipt endpoint is shared with the kiosk app and lives outside the admin API subpath.
  const printReceiptMutation = useMutation({
    mutationKey: ['printOrderReceipt'],
    mutationFn: ({ id, lang }: { id: number; lang: string }) =>
      axiosInstance.get<string>(`/${ORDERS}/${id}/receipt`, { params: { lang } }),
  });

  return { useOrderQuery, updateStatusMutation, printReceiptMutation };
};
